import { Session } from 'modules/core/hooks/useGetCurrentSession'

import { Group } from 'modules/expenses/hooks/useGroup'

import { isChangesRequestedGroup, isDraftGroup, isPendingGroup, isRejectedGroup } from './group'

const isOwnGroup = (group: Group, currentEmployeeId?: number) =>
  currentEmployeeId === group.owner?.id

export const canSendGroupForApproval = (group: Group, currentEmployee?: Session['employee']) =>
  (isDraftGroup(group) || isChangesRequestedGroup(group)) &&
  group.expensablesCount > 0 &&
  isOwnGroup(group, currentEmployee?.id)

export const canReviewGroup = (group: Group) => group.reviewable

export const canAddGroupToPayroll = (group: Group, canSync: boolean) =>
  group.addableToPayroll && canSync

export const canPayGroupWithSepa = (group: Group, canSync: boolean) =>
  group.payableWithSepa && canSync

export const canRemoveGroupFromPayroll = (group: Group, canSync: boolean) =>
  group.removableFromPayroll && canSync

export const canEditGroup = (group: Group, currentEmployeeId?: number) => {
  if (isDraftGroup(group) && isOwnGroup(group, currentEmployeeId)) return true

  return isPendingGroup(group) && group._policies?.edit.can
}

export const canDeleteGroup = (group: Group, currentEmployeeId?: number) => {
  if (isDraftGroup(group) && isOwnGroup(group, currentEmployeeId)) return true

  return isRejectedGroup(group) && group._policies?.destroy.can
}
